
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__marker",
  "use": "icon__marker-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 20\" id=\"icon__marker\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M10.5 1.25c-3.442 0-6.25 2.808-6.25 6.25 0 .967.396 2.026.942 3.145.547 1.123 1.26 2.294 1.978 3.364a56.114 56.114 0 0 0 2.847 3.887l.483.595.483-.595s1.421-1.744 2.852-3.887c.713-1.07 1.426-2.241 1.973-3.364.546-1.119.942-2.178.942-3.145 0-3.442-2.808-6.25-6.25-6.25zm0 1.25c2.769 0 5 2.231 5 5 0 .586-.308 1.558-.815 2.598-.508 1.045-1.202 2.177-1.89 3.222-1.148 1.72-1.929 2.666-2.295 3.125-.366-.459-1.147-1.406-2.295-3.125-.688-1.045-1.382-2.177-1.89-3.222C5.808 9.058 5.5 8.086 5.5 7.5c0-2.769 2.231-5 5-5zm0 3.75c-.688 0-1.25.562-1.25 1.25s.562 1.25 1.25 1.25 1.25-.562 1.25-1.25-.562-1.25-1.25-1.25z\" fill=\"currentColor\" /><path d=\"M.5 0h20v20H.5z\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconMarkerIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__marker" {...restProps} />
    })
  